import type { VisibleGroupKey } from "./types";

export const PANEL_WIDTH = 300;
export const PANEL_MAX_HEIGHT = 368;

export const ALL_GROUPS: VisibleGroupKey[] = [
	"screenFields",
	"advancedTriggers",
	"collections",
	"currentCollection",
	"otherCollections",
	"suggestedFields",
	"simpleVariable",
	"formulaVariable",
	"singleRowDatabaseVariables",
	"multiRowDatabaseVariables",
	"screenTables",
	"otherScreenLocations",
	"globalConstants",
	"reactions",
];
